import { Button } from 'react-bootstrap';
import { Relationship } from './types';

export default function RelationshipsList({
  relationships,
  deleteRelationship,
}: {
  relationships: Record<string, Relationship>;
  deleteRelationship: (params: { id: string }) => Promise<void>;
}) {
  return Object.values(relationships)
    .sort((a, b) => a.selection.localeCompare(b.selection))
    .map((relationship) => (
      <div key={relationship.id} className="d-flex align-items-center mb-2">
        <div className="flex-grow-1">
          <strong>{relationship.selection}</strong> is more important than{' '}
          <strong>
            {relationship.options
              .filter((option) => option !== relationship.selection)
              .join(' and ')}
          </strong>
        </div>
        <Button
          variant="warning"
          size="sm"
          onClick={() => deleteRelationship({ id: relationship.id })}
        >
          Delete Relationship
        </Button>
      </div>
    ));
}
